<div *ngIf="eventService?.displayCountdownTimerForSelectedEvent()">
    <div class="text-center countdown-aside">
        <h3 class="bla">Countdown to Kickoff</h3>
        <p class="countdown-title">{{title}}</p>
        <p class="countdown-title">{{subtitle}}</p>

        <div class="flip-clock">
            <span class="flip-clock_piece {{flipWeek}}">
                <div class="card-container">
                    <div>Weeks</div>
                    <div class="flip-clock__card card">
                        <div class="card__top">{{week}}</div>
                        <div class="card__bottom" attr.data-value="{{week}}"></div>
                        <div class="card__back" attr.data-value="{{week}}">
                           <div class="card__bottom" attr.data-value="{{week}}"></div>
                        </div>
                    </div>
                </div>
            </span>
            <span class="flip-clock_piece {{flipDay}}">
                <div class="card-container">
                    <div>Days</div>
                    <div class="flip-clock__card card">
                        <div class="card__top">{{day}}</div>
                        <div class="card__bottom" attr.data-value="{{day}}"></div>
                        <div class="card__back" attr.data-value="{{day}}">
                           <div class="card__bottom" attr.data-value="{{day}}"></div>
                        </div>
                    </div>
                </div>
            </span>
            <span class="flip-clock_piece {{flipHour}}">
                <div class="card-container">
                    <div>Hours</div>
                    <div class="flip-clock__card card">
                        <div class="card__top">{{hour}}</div>
                        <div class="card__bottom" attr.data-value="{{hour}}"></div>
                        <div class="card__back" attr.data-value="{{hour}}">
                           <div class="card__bottom" attr.data-value="{{hour}}"></div>
                        </div>
                    </div>
                </div>
            </span>
            <span class="flip-clock_piece {{flipMin}}">
                <div class="card-container">
                    <div>Min</div>
                    <div class="flip-clock__card card">
                        <div class="card__top">{{min}}</div>
                        <div class="card__bottom" attr.data-value="{{min}}"></div>
                        <div class="card__back" attr.data-value="{{min}}">
                           <div class="card__bottom" attr.data-value="{{min}}"></div>
                        </div>
                    </div>
                </div>
            </span>
            <span class="flip-clock_piece {{flipSec}}">
                <div class="card-container">
                    <div>Sec</div>
                    <div class="flip-clock__card card">
                        <div class="card__top">{{sec}}</div>
                        <div class="card__bottom" attr.data-value="{{sec}}"></div>
                        <div class="card__back" attr.data-value="{{sec}}">
                           <div class="card__bottom" attr.data-value="{{sec}}"></div>
                        </div>
                    </div>
                </div>
            </span>
        </div>
        <p>After kickoff, you can link your fundraiser to Facebook.</p>
        <hr>
    </div>
</div>